import { Microscope, ShieldCheck, Package, Eye, HeadphonesIcon, Award } from "lucide-react";

const POINTS = [
  { icon: Microscope, title: "Scientific Manufacturing", desc: "Every compound is synthesized under controlled laboratory conditions following rigorous quality protocols." },
  { icon: ShieldCheck, title: "Independent Laboratory Testing", desc: "All batches are verified by accredited third-party laboratories, free from manufacturer bias." },
  { icon: Award, title: "Verified Purity", desc: "Minimum 98% purity standard confirmed through HPLC and mass spectrometry analysis on every batch." },
  { icon: Package, title: "Premium Packaging", desc: "Tamper-evident, vacuum-sealed packaging engineered to preserve compound stability during transit." },
  { icon: Eye, title: "Full Transparency", desc: "Batch numbers, purity data, and Certificates of Analysis are available for every product, every time." },
  { icon: HeadphonesIcon, title: "Exceptional Support", desc: "Our research support team responds promptly to documentation requests and technical inquiries." },
];

export default function WhyChooseUs() {
  return (
    <section className="relative py-24 bg-section-tint grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto px-6 md:px-12 lg:px-16 rounded-3xl my-4" data-testid="why-choose-us-section">
      <div>
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-brandblue-600">Why Choose True Impact</span>
          <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-display leading-tight">
            Setting the Standard for Research-Grade Peptides
          </h2>
          <p className="mt-5 text-base text-slate-600 leading-relaxed">
            We built True Impact Peptides on a single principle: research deserves compounds it can trust. Every product reflects our commitment to laboratory excellence, transparency, and scientific integrity.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {POINTS.map((p) => (
            <div key={p.title} className="p-5 rounded-2xl bg-white border border-slate-200 card-lift hover:shadow-blue-glow-sm hover:border-blue-200" data-testid={`why-choose-point-${p.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="h-9 w-9 rounded-lg bg-blue-50 flex items-center justify-center mb-3">
                <p.icon className="h-4.5 w-4.5 text-brandblue-600" strokeWidth={1.5} />
              </div>
              <h3 className="font-display font-semibold text-sm text-slate-900 mb-1.5">{p.title}</h3>
              <p className="text-xs text-slate-500 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
    </section>
  );
}
